module.exports = __webpack_public_path__ + "static/media/mg.67f5922d.svg";